export const en_US = 'en_US';
export const pt_BR = 'pt_BR';
export const es_ES = 'es_ES';
export const fr_FR = 'fr_FR';
export const de_DE = 'de_DE';
export const it_IT = 'it_IT';
